export default function CoinsSection({ coins }) {
  return (
    <div className="level-points">
        <span className="font-black game-coins">
          {coins}
        </span>
      </div>
    
  );
}